import React, { Component } from 'react';
import moment from 'moment';
import Spinner from '@dbk/ui-spinner';
import ContactItem from './contact-item';
import Text from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
class Contacts extends Component {

  componentWillMount() {
    this.props.fetchUserList();
  }

  render() {
    const {
      loading,
      userList,
      selectedContact,
      i18n: { messages }
    } = this.props;
    return (
      <div className="bar margin-bottom-5">
        {loading && <div className="center-content pad-top-15"><Spinner /></div>}
        {!loading && userList && userList.length !== 0  ?
          <div className="contact-list">
            {userList.map((user) => (
              <ContactItem
                name={user.userName}
                online={user.online}
                message={user.lastMessage}
                timestamp={
                  user.lastMessageMeta
                }
                onClick={() => selectedContact(user)}
              />
            ))}
          </div>
          :
          <div className="contact-item no-user-list">
            <Text>{messages['app.chat.emptyList']}</Text>
          </div>
        }
      </div>
    );
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    }
  }
})(Contacts);
